import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap, finalize } from 'rxjs/operators';
import { EncryptionService } from '../services/encryption.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { responseStatus } from '../const/responseStatus.const';
import { NgxSpinnerService } from 'ngx-spinner';
@Injectable({
  providedIn: 'root',
})
export class GetInterceptor implements HttpInterceptor {
  private recentErrors = new Set<string>();
  private errorTimeout = 5000;
  constructor(
    private router: Router,
    private encryptionService: EncryptionService,
    private toaster: ToastrManager,
     private spinner: NgxSpinnerService
  ) {
  }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.spinner.show();
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          let decryptedBody: any;
          if (!event.url?.includes('upload') && !event.url?.includes('.json')) {
            try {
              const decryptedData = this.encryptionService.decryptData(
                event.body?.data
              );
              decryptedBody = {
                response: event.body?.response,
                data: JSON.parse(decryptedData),
              };
              this.handleResponse(decryptedBody, req.method);
              return event.clone({ body: decryptedBody });
            } catch (e) {
              console.error('Decryption failed:', e);
              return event;
            }
          }
        }
        return event;
      }),
      tap({
        error: (error: HttpErrorResponse) => {
          this.handleError(error);
        },
      }),
      finalize(() => {
        this.spinner.hide();
        // You can stop loader/spinner here if needed
      })
    );
  }
  private handleResponse(body: any, method: string): void {
    if (body?.response?.status) {
      switch (body.response.status) {   
        case responseStatus.BADREQUEST:
        case responseStatus.UNAUTHORIZED:
        case responseStatus.FORBIDDEN:
        case responseStatus.REQUESTTIMEOUT:
        case responseStatus.INTERNALSERVERERROR:
               this.toaster.errorToastr(body.response.message);
          if (
            body.response.status === responseStatus.UNAUTHORIZED ||
            body.response.status === responseStatus.FORBIDDEN
          ) {
            this.router.navigate(['/dasboard']);
            localStorage.clear();
          }
          break;
      }
    }
  }
  private handleError(error: HttpErrorResponse): void {
    const errorMessage =
      error?.error?.response?.message ||
      error?.error?.message ||
      error?.message ||
      'Something went wrong';
    if (errorMessage === 'SomethingWentWrong') {
      return;
    }
    if (!this.recentErrors.has(errorMessage)) {
      this.recentErrors.add(errorMessage);
      this.toaster.errorToastr(errorMessage);
      setTimeout(() => this.recentErrors.delete(errorMessage), this.errorTimeout);
    }
    if (
      error.status === responseStatus.UNAUTHORIZED ||
      error.status === responseStatus.FORBIDDEN
    ) {
      this.router.navigate(['/dasboard']);
      localStorage.clear();
    }
  }
}